import { useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import {
  bookAppointment,
  checkSchedule,
  getEncounterRecord,
  getSlots,
  updateAppointmentRequest,
  getlistPractitioners
} from "../api/AppointmentRequests";
import { failed, success } from "../../common/Toastify";
import { useFormik } from "formik";
import moment from "moment";
import { useSelector } from "react-redux";
import { generatePass } from "../AppointmentRequests/Constants";
import { getSignature } from "../../Zoom/functions";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { LOCATIONS } from "../../common/location";
import { editQuestionnaireResponse } from "../../api/Questionnaire";
import { getSingleUser } from "../../api/Individual";
import { decryptData } from "../../EncryptDecrypt";
import { CircularProgress, Skeleton } from "@mui/material";
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import TextInput from "../../common/textfield/TextInput";
import SelectFiled from "../../common/textfield/SelectFiled";
import { Button } from "../../common/Button";
import { DateSelectorWithoutFormik } from "../../common/textfield/DateSelector";
import { Form } from "react-bootstrap";
import { getScheduleSlots } from "../../api/Schedule";
import { getOrganization } from "../../api/Organization";
import { axios } from "../../../lib/axios";
import { createQuestionnaireResponse } from "../../api/Questionnaire";
import { buildSessionTopic } from "../../../utils/ZoomSessionSupport";
import { validation, conditionalValidation } from "../../../utils/constants";
import {
  computeServiceCategoryAvailabilities as buildScheduleServiceCategoryAvailabilities,
  filterSlotsForSelectedDay,
  getAvailableDayKeysForCategory,
  getDateKey,
  getScheduleDateOptions,
  mergeCategoryIdsByDay,
  mergeSlotsByStart,
  scheduleMatchesSelectedOrg,
  sortSlotsByStart
} from "../../../utils/ScheduleAvailabilitySupport";

/** Same as BookAppointment — schedule rows for org (parent/child/category org). */
const ScheduleAppointmentWR = ({
  onShow,
  onHide,
  encounterId,
  questionnaireData,
  patientName,
  patientId,
  type = "patient",
  questionnaireResponseId,
  orgId: orgIdProp,
}) => {
  const [encounterData, setEncounterData] = useState(null);
  const [btnLoading, setBtnLoading] = useState(false);
  const [practitionerList, setPractitionerList] = useState([]);
  const user = useSelector((state) => state?.auth?.user);
  const [slotsLoading, setSlotsLoading] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState("");
  const [availableSlots, setAvailableSlots] = useState([]);
  const [availableDays, setAvailableDays] = useState([]);
  const [slotUnavailable, setSlotUnavailable] = useState(false);
  const [practitionerId, setPractitionerId] = useState("");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [serviceCategory, setServiceCategory] = useState([]);
  const [categoriesByDay, setCategoriesByDay] = useState({});
  const [reservedCategories, setReservedCategories] = useState({});
  const [scopeOfPractice, setScopeOfPractice] = useState(null);
  const practitionerUniqueId = useSelector( (state) => state?.auth?.user?.["custom:unique_id"]);
  const adminOrgs = useSelector((state) => state?.auth?.user?.organizations);
  const bookingOrgId = orgIdProp;
  const [Questions, setQuestions] = useState([]);
  const [fetchedSchedules, setFetchedSchedules] = useState([]);
  const [computedServiceCategories, setComputedServiceCategories] = useState({});

  const sortedObj = data => {
    return data.sort((a,b) => {
        return a.name > b.name ? 1 : -1
    });
  }

  /** Same as BookAppointment — merge category-by-day maps without losing keys. */
  const merge = (obj1, obj2) => {
    for (const key in obj2) {
      if (obj1[key]) {
        if (Array.isArray(obj1[key]) && Array.isArray(obj2[key])) {
          obj2[key].forEach((cat) => {
            if (!obj1[key].includes(cat)) obj1[key].push(cat);
          });
        } else {
          obj1[key] = obj2[key];
        }
      } else obj1[key] = obj2[key];
    }
    return obj1;
  };

  useEffect(() => {
    getEncounterRecord({ encounterId: encounterId })
      .then((res) => {
        if (res?.status === true) {
          setEncounterData(res?.data);
        }
      })
      .catch((res) =>
        failed(
          res?.response?.data?.message ||
            res?.response?.data?.error ||
            res.message
        )
      );
  }, [encounterId]);

  const formik = useFormik({
    initialValues: {
      title: "",
      patient: "",
      date: "",
      serviceCategory: "",
      availableSlot: "",
      preferredChannel: "",
      returnTelephoneNumber: "",
      returnTelephoneNumberExt: "",
      practitionerPreference: "",
      practitioner: "",
    },
    validationSchema: Yup.object({
      title: conditionalValidation(
        Yup.string(),
        {
          validation,
          label: "Reason for Visit",
          mandatory: true
        }),
      patient: conditionalValidation(
        Yup.string(),
        {
          validation,
          label: "Patient",
          mandatory: true
        }),
      date: conditionalValidation(
        Yup.string(),
        {
          validation,
          label: "Date",
          mandatory: true
        }),
      serviceCategory: conditionalValidation(
        Yup.string(),
        {
          validation,
          label: "Appointment Type",
          mandatory: true
        }),
      availableSlot: Yup.object().required("Required slots field."),
      preferredChannel: conditionalValidation(
        Yup.string(),
        {
          validation,
          label: "Preferred Channel",
          mandatory: true
        }),
      returnTelephoneNumber: conditionalValidation(
        Yup.string()
          .matches(
            /^(?:\+?1[-. ]?)?\(?[0-9]\d{2}\)?[-. ]?\d{3}[-. ]?\d{4}$/,
            "Enter Valid Return Telephone Number."
          ),
          {
            validation,
            label: "Return Telephone Number",
            mandatory: true
          }),
      returnTelephoneNumberExt: conditionalValidation(
        Yup.string().matches(/^\d{0,4}$/, "Must be 4 digit or less."),
        {
          validation,
          label: "Extension"
        }),
      practitionerPreference: conditionalValidation(
        type === "patient"
          ? Yup.string().required("Required Practitioner Preference field.")
          : null,
          {
            validation
          }),
      practitioner:
        type === "patient"
          ? Yup.mixed().when(["practitionerPreference"], {
              is: (practitionerPreference) =>
                practitionerPreference !== "no preference",
              then: Yup.string().required("Required Practitioner field."),
              otherwise: Yup.mixed().notRequired(),
            })
          : null,
    }),
    onSubmit: async (values) => {
      values.title = values.title?.trim();
      setBtnLoading(true);
      try {
        let slot = null;
        let utcStart = values?.availableSlot?.start;
        let utcEnd = values?.availableSlot?.end;
        let selectedServiceCategory = values?.serviceCategory;
    
        selectedServiceCategory = serviceCategory?.filter(
          (categoryData) => categoryData.value === selectedServiceCategory
        )?.[0];

        const reservedSlot =
          values?.availableSlot?.status === "busy-reserved";
        if (
          selectedServiceCategory &&
          (reservedSlot ||
            selectedServiceCategory?.value?.endsWith("busyReserved"))
        ) {
          selectedServiceCategory = structuredClone(selectedServiceCategory);
          selectedServiceCategory.id =
            selectedServiceCategory?.value?.split("-")[0];
          if (selectedServiceCategory?.value?.endsWith("busyReserved")) {
            selectedServiceCategory.name = selectedServiceCategory.name
              .substring(12)
              .trim();
          }
        }

        const slotSc = values?.availableSlot?.serviceCategory?.[0];
        const serviceCategoryCode =
          selectedServiceCategory?.id ||
          selectedServiceCategory?.value ||
          slotSc?.id ||
          slotSc?.coding?.[0]?.code ||
          selectedServiceCategory?.coding?.[0]?.code;
        const serviceCategoryDisplay =
          selectedServiceCategory?.display ||
          selectedServiceCategory?.name ||
          slotSc?.name ||
          slotSc?.coding?.[0]?.display;

        const serviceCategoryPayload = [
          {
            coding: [
              {
                system: "http://florizel.com/AppointmentServiceCategory",
                code: serviceCategoryCode,
                display: serviceCategoryDisplay,
              },
            ],
            text: `Appointment for ${serviceCategoryDisplay}`,
          },
        ];
    
        if (formik?.values?.practitionerPreference === "no preference") {
          values.practitioner = values?.availableSlot?.actorId;
          values.scheduleId = values?.availableSlot?.scheduleId;
        } else {
          values.scheduleId = values?.availableSlot?.scheduleId;
        }
    
        values.orgId = bookingOrgId;
        const requestedPeriod = [{ start: utcStart, end: utcEnd }];
        const topic = user?.name[0]?.text.trim();
        const password = generatePass();
    
        const signatureResponse = await getSignature({
          topic,
          role: 0,
          password,
        });
        const sessionToken = signatureResponse?.data?.sessionToken;

        
    
        //const questionResponse = Questions.map((item) => ({
        //  id: item.linkId,
        //  questionId: item?.id || null,
        //  question: item.text,
        //  answer: item.answerOption.map((option) => ({
        //    id: option.id,
        //    questionId: item?.id || null,
        //    required: item.required,
        //    answer: "",
        //    option: item.answerType === "radio" ? option.text : null,
        //   value: item.answerType === "dropDown" ? option.text : null,
        //    name: item.answerType === "dropDown" ? option.text : null,
        //  })),
        //  questionType: item.answerType,
        //  required: item.required,
        //}));
    
        // Set specific answers
        //questionResponse[0].answer[0].answer = patientName.replace(/\b\w/g, (c) =>
        //  c.toUpperCase()
        //);
        //questionResponse[1].answer[0].answer = values?.returnTelephoneNumber;
        //questionResponse[2].answer[0].answer =
        //  questionnaireData?.callerRelationship === "Self";
        //questionResponse[4].answer[0].answer = questionnaireData?.consent === "Yes";
        //questionResponse[6].answer[0].answer = values?.title;
        //questionResponse[5].answer[0].answer =
        //  Object.keys(LOCATIONS).find(
        //    (key) => LOCATIONS[key] === encounterData?.patientLocation
        //  ) || "";
    
        //const questionnaireResponseRes = await createQuestionnaireResponse({
        //  patientID: patientId,
        //  encounterId: "",
        //  questionResponse,
        //  appointmentId: "",
        //  questionnaire: values.questionnaireId,
        //  authorName: user?.name[0]?.text,
        //  authorType: "Practitioner",
        //  authorId: user["custom:practitioner_id"],
        //});
    
        //const questionnaireResponseId = questionnaireResponseRes.data.id;
        
    
        let intakeQuestions = {};
        if (type === "patient") {
          intakeQuestions = {
            //questionnaireResponseId: {
            //  reference: `QuestionnaireResponse/${questionnaireResponseId}`,
            //},
            preferredChannel: values?.preferredChannel,
            callerName: patientName.replace(/\b\w/g, (c) => c.toUpperCase()),
            callerNumber: values?.returnTelephoneNumber,
            callerNumberExt: values?.returnTelephoneNumberExt,
            callerRelationship: questionnaireData?.callerRelationship,
            reason: values?.title,
            location: encounterData?.patientLocation || "",
          };
        }
    
        const bookAppointmentRes = await bookAppointment({
          serviceCategory: serviceCategoryPayload,
          slot,
          sessionToken,
          requestType:
            formik?.values?.practitionerPreference === "no preference"
              ? "organization"
              : "provider",
          practitionerId: values?.practitioner || practitionerUniqueId,
          patientId,
          requestedPeriod,
          description: values?.title,
          intakeQuestions,
          patientLocation: intakeQuestions.location,
          scheduleId: values?.scheduleId,
          orgId: bookingOrgId,
        });
    
        if (type === "patient") {
          const updatePayload = {
            isHostJoined: false,
            sessionToken,
            id: bookAppointmentRes?.result?.id,
            status: "booked",
            patientId: bookAppointmentRes?.result?.patientId,
            practitionerId: bookAppointmentRes?.result?.practitionerId,
            proceedWith: questionnaireData?.howToProcced || "SCHEDULE",
            intakeQuestions,
            patientLocation: intakeQuestions.location,
          };
    
          await updateAppointmentRequest(updatePayload);
          //await editQuestionnaireResponse(questionnaireResponseId, {
          //  encounterId: bookAppointmentRes?.result?.encounterId,
          //  authorName: user?.name[0]?.text,
          //  authorType: "Practitioner",
          //  authorId: user["custom:practitioner_id"],
          //});
    
          onHide();
          success("Appointment Scheduled");
        }
      } catch (error) {
        failed(
          error?.response?.data?.message ||
            error?.response?.data?.error ||
            error.message
        );
      } finally {
        setBtnLoading(false);
      }
    },
  });
  useEffect(() => {
    if (questionnaireData) {
      const phoneNumber = questionnaireData?.callerNumber || "";
      const match = phoneNumber.match(/ext\s*(\d+)/i);
      const extension = match ? match[1] : questionnaireData?.callerNumberExt || "";
      const numberWithoutExt = match ? phoneNumber.replace(/ext\s*\d+/i, "").trim() : phoneNumber;
  
      formik.setFieldValue("title", questionnaireData?.intakeReason || "");
      formik.setFieldValue("returnTelephoneNumber", numberWithoutExt);
      formik.setFieldValue("returnTelephoneNumberExt", extension);
      formik.setFieldValue("patient", patientName || "");
    }
  }, []);

  useEffect(() => {
    const orgAdminId = adminOrgs?.[0]?.id;
    if (!orgAdminId) return;
    getOrganization(orgAdminId)
      .then(async (res) => {
        if (res.data?.assignedQuestionnaire?.["telephone-intake"]) {
          const response = await axios.get(
            `questionnaire/${res.data?.assignedQuestionnaire?.["telephone-intake"]}`
          );
          formik.setFieldValue("questionnaireId", response?.data?.id);
          setQuestions(
            response?.data?.item?.map((item) => ({
              ...item,
              name: item?.text,
              value: item?.id,
            }))
          );
        }
      })
      .catch((res) => {
        failed(
          res?.response?.data?.message ||
            res?.response?.data?.error ||
            res.message
        );
      });
  }, [adminOrgs]);

  useEffect(() => {
    if (!encounterData?.patientLocation || !bookingOrgId) return;
    const scope = encounterData.patientLocation;
    setScopeOfPractice(scope);

    getlistPractitioners({ orgId: bookingOrgId, scopeOfPractice: scope })
      .then(async (res) => {
        let allPracts = res.result?.filter((pra) => pra.active);
        let activePractitioners = [];
        let startDate =
          formik?.values?.date?.length > 0 ? moment(formik?.values?.date) : moment();
        startDate = moment(startDate).utc().format("YYYY-MM-DDTHH:mm:ss") + "Z";

        await checkSchedule({
          actorId: user["custom:unique_id"],
          date: startDate,
          orgId: bookingOrgId,
        })
          .then((activeSchedules) => {
            if (!activeSchedules?.data) {
              failed(activeSchedules?.message);
              setServiceCategory([]);
              setCategoriesByDay({});
              setPractitionerList([]);
              return;
            }
            if (!Array.isArray(activeSchedules.data))
              activeSchedules.data = [activeSchedules.data];

            activeSchedules.data = activeSchedules.data.filter((sch) => {
              if (!scheduleMatchesSelectedOrg(sch, bookingOrgId)) return false;
              if (!sch.serviceCategory?.length) return false;
              return sch.serviceCategory.some((cat) =>
                moment.utc(cat.date).isSameOrAfter(moment.utc(startDate).startOf('day'))
              );
            });

            activeSchedules.data.forEach((schedule) => {
              let active = allPracts.find(
                (person) =>
                  person.id === schedule.actorId &&
                  !activePractitioners.some((exists) => exists.id === schedule.actorId)
              );
              if (active) activePractitioners.push(active);
            });
            setPractitionerList(
              activePractitioners.map((ele) => ({
                value: ele?.id,
                name: ele?.name?.[0]?.text
                  ?.split(" ")
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" "),
                id: ele?.id,
                orgId:
                  ele?.orgId ??
                  ele?.managingOrganization?.[0]?.reference?.split("/")?.[1],
              }))
            );
          })
          .catch((activeSchedules) => {
            failed(
              activeSchedules?.response?.data?.message ||
                activeSchedules?.response?.data?.error ||
                activeSchedules.message
            );
            setServiceCategory([]);
            setCategoriesByDay({});
            setPractitionerList([]);
          });
      })
      .catch((err) => {
        console.log("error fetching practioner list", err);
      });
  }, [encounterData, bookingOrgId, formik?.values?.date]);

  const sortedSlots = (data) => {
    return sortSlotsByStart(data);
  };

  /**
   * Loads available slots for a given date and appointment type.
   * Handles reserved slots, merges with available slots, and sorts them.
   */
  const loadSlotData = (selectedDate, selectedType) => {
    setSlotsLoading(true);
    setSlotUnavailable(false);

    const today = moment();
    const date = moment(selectedDate || formik?.values?.date);
    const type = selectedType || formik?.values?.serviceCategory;
    const selectedDayKey = date.format("YYYY-MM-DD");
    const dateUtc = moment(date).utc().format("YYYY-MM-DDTHH:mm:ss") + "Z";
    const selectedCategory = serviceCategory.find(
      (item) => (item.id || item.value) === type || item.value === `${type}-busyReserved`
    );
    const scheduleDateOptions = getScheduleDateOptions(selectedCategory?.date);

    if (!type) {
      setSlotsLoading(false);
      return;
    }

    if (type?.endsWith("busyReserved")) {
      let slots = reservedCategories[type.split("-")[0]];
      slots = filterSlotsForSelectedDay(slots, selectedDayKey, {
        now: today.toDate(),
        options: scheduleDateOptions,
      });
      slots = sortedSlots(slots || []);
      if (!slots?.length) {
        setSlotUnavailable(true);
      }
      setAvailableSlots(slots || []);
      setSlotsLoading(false);
      return;
    }

    let reservedSlots = reservedCategories[type] || [];
    reservedSlots = filterSlotsForSelectedDay(reservedSlots, selectedDayKey, {
      now: today.toDate(),
      options: scheduleDateOptions,
    });
    reservedSlots = sortedSlots(reservedSlots);

    const params = {
      actorId: practitionerId || user["custom:unique_id"],
      date: dateUtc,
      serviceCategoryId: type,
      orgId: bookingOrgId,
    };

    if (formik?.values?.practitionerPreference === "no preference") {
      if (scopeOfPractice) {
        params.scopeOfPractice = scopeOfPractice;
      } else if (encounterData?.patientLocation) {
        params.scopeOfPractice = encounterData.patientLocation;
      }
    }

    getSlots(params)
      .then((res) => {
        const available = mergeSlotsByStart(
          filterSlotsForSelectedDay(res?.data?.availableSlots || [], selectedDayKey, {
            now: today.toDate(),
            options: scheduleDateOptions,
          }),
          reservedSlots
        );
        setAvailableSlots(available);

        if (available.length < 1) {
          setSlotUnavailable(true);
        }
      })
      .catch((err) => {
        if (reservedSlots.length > 0) {
          setAvailableSlots(reservedSlots);
        } else {
          failed(
            err?.response?.data?.message ||
              err?.response?.data?.error ||
              err?.message
          );
          setAvailableSlots([]);
        }
      })
      .finally(() => setSlotsLoading(false));
  };

  const handleDateSelection = (val) => {
    const isValidDate = moment(val, 'MMM-DD-YYYY').isValid()
    setAvailableSlots([])
    if(type === "patient"){
        if(formik.values.practitionerPreference == ''){
            failed('Please select practitioner preference')
        }else{
            if(isValidDate){
                formik.setFieldValue("date", val.format("YYYY-MM-DD"));
                // load slots here
                loadSlotData(val.format("YYYY-MM-DD"))
            }else{
                formik.setFieldError('date', 'Invalid date format')
            }
        }
    }else{
        if(isValidDate){
            formik.setFieldValue("date", val.format("YYYY-MM-DD"));
            loadSlotData(val.format("YYYY-MM-DD"))
        }else{
            formik.setFieldError('date', 'Invalid date format')
        }
    }       
  }

  const handlePractitionerChange = (event) => {
    setPractitionerId(event?.target?.value)
    formik.setFieldValue("practitioner", formik?.values?.practitionerPreference === "no preference" ? "" : event?.target?.value);
    formik.setFieldValue("serviceCategory", ""); 
    formik.setFieldValue("date", "");
    setServiceCategory([]);
    setAvailableSlots([]);
    setCategoriesByDay({});
  };

  const handlePractitionerPreferenceChange = (e) => {
    setPractitionerId(null); 

    formik.setFieldValue("practitioner", "");
    formik.setFieldValue("serviceCategory", ""); 
    formik.setFieldValue("date", "");
    setServiceCategory([]);
    setAvailableSlots([]);        
    setCategoriesByDay({});
    formik.setFieldValue("practitionerPreference", e.target.id);
  };

  const findUpcoming = (event) => {
    setSlotUnavailable(false);        
    let targetVal = event?.target?.value;
    formik.setFieldValue("serviceCategory", targetVal);
    setAvailableSlots([])
    formik.setFieldValue("date", "");
    setSelectedSlot("");
    formik.setFieldValue("availableSlot", "");
    highLightDates();
  }

  const renderDay = (props) => {
    const { selectedDate, day, dayComponent, ...other} = props;
    const today = moment().startOf('day');
    const isAvailable = availableDays.includes(day.clone().format("YYYY-MM-DD"));
    const isSelected = day.isSame(selectedDate, "day");
    const isToday = day.clone().isSame(today, "day");
    const isPast = day.clone().isBefore(today, "day")

    return (
        <PickersDay {...dayComponent} 
            disabled={isPast || !isAvailable}
            style={isAvailable ? {background: "#accfeb"}: {background: "white" }} />
    );
  }

  useEffect(() => {
    let cancelled = false;

    const startLocal =
      formik?.values?.date?.length > 0 ? moment(formik?.values?.date) : moment();
    const startDate = moment(startLocal).utc().format("YYYY-MM-DDTHH:mm:ss") + "Z";
    const start = startLocal.format("YYYY-MM-DD");

    const appendReservedCategories = (categories, reservedSlots) => {
      let reservedByDay = {};

      Object.keys(reservedSlots).forEach((key) => {
        if (
          !reservedSlots[key]?.length ||
          !(
            reservedSlots[key][0]?.serviceCategory?.[0]?.id ||
            reservedSlots[key][0]?.serviceCategory?.[0]?.coding?.[0]?.code
          )
        ) {
          return;
        }

        if (getDateKey(reservedSlots[key][0]?.start) < start) {
          return;
        }

        const categoryLabel =
          reservedSlots[key]?.[0]?.serviceCategory[0]?.name ||
          reservedSlots[key]?.[0]?.serviceCategory[0]?.coding?.[0]?.display;
        const categoryId =
          reservedSlots[key][0]?.serviceCategory?.[0]?.id ||
          reservedSlots[key][0]?.serviceCategory?.[0]?.coding?.[0]?.code;
        const alreadyListed = categories.some((item) => item.value === categoryId);

        if (!alreadyListed) {
          let timeSlot = reservedSlots[key][0]?.serviceCategory?.[0]?.timeSlot;
          if (!timeSlot) {
            const timeSlotString = reservedSlots[key]?.[0]?.serviceCategory[0]?.coding?.[0]?.display
              ?.split("(")[1]
              ?.split(")")[0]
              ?.split(" ");
            if (timeSlotString?.length) {
              timeSlot = {
                value: parseInt(timeSlotString[0], 10),
                unit: "minutes",
              };
            }
          }

          const name = `${
            formik.values.practitioner?.length > 0 ? "Reserved for " : ""
          } ${categoryLabel}`;

          categories.push({
            name,
            id: categoryId,
            value: categoryId,
            timeSlot,
            orgId: reservedSlots[key][0].orgId,
            date: reservedSlots[key][0]?.categoryDate || reservedSlots[key][0]?.start,
            status: "busy-reserved",
          });
        }

        reservedSlots[key].forEach((slot) => {
          const datekey = getDateKey(slot?.start);
          if (datekey && datekey >= start) {
            reservedByDay = mergeCategoryIdsByDay(reservedByDay, { [datekey]: [categoryId] });
          }
        });
      });

      if (Object.keys(reservedByDay).length > 0) {
        setCategoriesByDay((prev) => mergeCategoryIdsByDay(prev, reservedByDay));
      }
    };

    if (
      formik?.values?.practitionerPreference &&
      ((formik?.values?.practitionerPreference === "select practitioner" &&
        practitionerId) ||
        formik?.values?.practitionerPreference === "no preference")
    ) {
      checkSchedule({
        actorId:
          formik?.values?.practitionerPreference === "no preference"
            ? user["custom:unique_id"]
            : practitionerId,
        date: startDate,
        orgId:
          formik?.values?.practitionerPreference === "no preference"
            ? bookingOrgId
            : null,
      })
        .then(async (res) => {
          if (cancelled) return;

          if (!res?.data) {
            failed(res?.message);
            setServiceCategory([]);
            setCategoriesByDay({});
            return;
          }

          let categories = [];
          if (!Array.isArray(res.data)) res.data = [res.data];

          const schedules = res.data.filter((sch) =>
            scheduleMatchesSelectedOrg(sch, bookingOrgId)
          );
          setFetchedSchedules(schedules);
          let tempByDay = {};

          schedules.forEach((schedule) => {
            schedule.serviceCategory?.forEach((category) => {
              if (category.id) {
                const key = moment.utc(category?.date).format("YYYY-MM-DD");
                const catMoment = moment.utc(category?.date);
                if (
                  catMoment.isSameOrAfter(moment.utc(startDate).startOf('day')) &&
                  !categories.some((item) => item.value === category.id)
                ) {
                  categories.push({ ...category, value: category?.id });
                }
                if (catMoment.isSameOrAfter(moment.utc(startDate).startOf('day'))) {
                  if (tempByDay[key]) {
                    if (!tempByDay[key].some((id) => id === category.id)) {
                      tempByDay[key].push(category.id);
                    }
                  } else {
                    tempByDay[key] = [category.id];
                  }
                }
              }
            });
          });

          setCategoriesByDay((prev) => mergeCategoryIdsByDay(prev, tempByDay));

          let reservedSlots = {};
          const reservedResponses = await Promise.allSettled(
            schedules.map((schedule) =>
              getScheduleSlots(schedule.id, "busy-reserved", bookingOrgId).then(
                (resp) => ({ schedule, resp })
              )
            )
          );

          if (cancelled) return;

          reservedResponses.forEach((result) => {
            if (result.status === "rejected") {
              failed(
                result.reason?.response?.data?.message ||
                  result.reason?.response?.data?.error ||
                  result.reason?.message
              );
              return;
            }

            const { schedule, resp } = result.value;
            (resp.data || [])
              ?.forEach((slot) => {
                slot.serviceCategory?.forEach((cat) => {
                  const serviceCategoryId = cat.id || cat.coding?.[0]?.code;
                  if (!serviceCategoryId) return;
                  const categoryDate = schedule.serviceCategory?.find((item) => item.id === serviceCategoryId)?.date;
                  if (getDateKey(slot?.start, getScheduleDateOptions(categoryDate)) < start) return;

                  const slotEntry = {
                    start: slot?.start,
                    end: slot?.end,
                    scheduleId: slot?.scheduleId,
                    serviceCategory: [cat],
                    categoryDate,
                    orgId: slot?.orgId,
                    actorId: schedule.actorId,
                    status: "busy-reserved",
                  };

                  if (reservedSlots[serviceCategoryId]) {
                    reservedSlots[serviceCategoryId].push(slotEntry);
                  } else {
                    reservedSlots[serviceCategoryId] = [slotEntry];
                  }
                });
              });
          });

          appendReservedCategories(categories, reservedSlots);

          setReservedCategories(reservedSlots);
          setServiceCategory([...categories]);
        })
        .catch((res) => {
          if (cancelled) return;
          failed(
            res?.response?.data?.message ||
              res?.response?.data?.error ||
              res.message
          );
          setServiceCategory([]);
          setCategoriesByDay({});
        });
    }

    return () => {
      cancelled = true;
    };
  }, [
    practitionerId,
    formik?.values?.practitioner,
    formik?.values?.practitionerPreference,
    bookingOrgId,
  ]);

  const highLightDates = () => {
    const selectedCategory = serviceCategory.find(
      (item) => (item.id || item.value) === formik.values.serviceCategory
    );
    setAvailableDays(getAvailableDayKeysForCategory({
      serviceCategories: serviceCategory,
      selectedServiceCategoryId: formik.values.serviceCategory,
      availabilityByCategory: computedServiceCategories,
      options: getScheduleDateOptions(selectedCategory?.date),
    }));
  };
  
  
  const fetchSchedules = async () => {
    const schedulesWithSlots = await Promise.all(
        fetchedSchedules.map(async (schedule) => {
        const slotsResponse = await getScheduleSlots(
          schedule.id,
          null,
          bookingOrgId
        );
        const slots = slotsResponse.data || [];
        return { ...schedule, slots };
        })
    );

    const result = computeServiceCategoryAvailabilities(schedulesWithSlots);
    setComputedServiceCategories(result);
  };
  
  
  const computeServiceCategoryAvailabilities = (schedules) => buildScheduleServiceCategoryAvailabilities(schedules);

  useEffect(() => {
      if(fetchedSchedules.length > 0 && formik?.values?.practitionerPreference) {
          fetchSchedules()
      }
  }, [fetchedSchedules, formik?.values?.practitionerPreference, bookingOrgId]);

  return (
    <>
      <Modal
        backdropClassName
        backdrop={"static"}
        show={onShow}
        onHide={onHide}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="custom-dialog appointment-custom-modal"
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title id="contained-modal-title-vcenter">
            Create Appointment for{" "}
            <span style={{ textTransform: "capitalize" }}>{patientName}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            className="common-form border-fields"
            onSubmit={formik.handleSubmit}
          >
            {isLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "50vh",
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <>
                <Row>
                  <Col>
                    <TextInput
                      keyField={"title"}
                      label={"Reason for visit"}
                      formik={formik}
                      placeholder={"Reason for visit"}
                    />
                  </Col>
                  <Col>
                    {!type ? null : (
                      <TextInput
                        keyField={"patient"}
                        label={"Patient Name"}
                        formik={formik}
                        disabled={true}
                        placeholder={"Patient Name"}
                        style={{ textTransform: "capitalize" }}
                      />
                    )}
                  </Col>
                </Row>
                {type === "patient" ? (
                  <Row>
                    <Col>
                      <Form.Check.Label
                        style={{
                          textTransform: "capitalize",
                          fontSize: "14px",
                        }}
                      >
                        {"practitioner preference ?"}
                      </Form.Check.Label>{" "}
                      <span className="requiredField">&#42;</span>
                      <br />
                      {["select practitioner", "no preference"].map((val) => (
                        <Form.Check
                          style={{
                            textTransform: "capitalize",
                            fontSize: "14px",
                            marginRight: "45px",
                          }}
                          inline
                          checked={formik.values.practitionerPreference === val}
                          type={"radio"}
                          label={val}
                          id={val}
                          name="practitioner preference"
                          onChange={handlePractitionerPreferenceChange}
                        />
                      ))}
                      {formik?.touched["practitionerPreference"] &&
                      formik?.errors["practitionerPreference"] ? (
                        <div className="error-text">
                          {formik?.errors["practitionerPreference"]}{" "}
                        </div>
                      ) : null}
                    </Col>
                    {formik?.values?.practitionerPreference ===
                    "select practitioner" ? (
                      <Col>
                        <SelectFiled
                          keyField={"practitioner"}
                          label={"Select Practitioner"}
                          formik={formik}
                          options={sortedObj(practitionerList)}
                          isReadOnly={true}
                          onChange={handlePractitionerChange}
                        />
                      </Col>
                    ) : (
                      <Col></Col>
                    )}
                  </Row>
                ) : null}
                <Row className="mt-3">
                  <Col>
                    <SelectFiled keyField={"serviceCategory"} label={"Appointment Type"} formik={formik} options={sortedObj(serviceCategory)} disabled={!formik.values.practitionerPreference} onChange={findUpcoming} />
                  </Col>
                  <Col>
                    <DateSelectorWithoutFormik disabled={!formik?.values?.serviceCategory} formik={formik} keyField={'date'} label="Date" value={(formik?.values?.date?.length > 0) ? moment(formik?.values?.date) : null} handleChange={(value) => { handleDateSelection(value)}} minDate={moment()} defaultValue={moment()} onMonthChange={highLightDates} onOpen={highLightDates} renderDay={(day, selectedDate, dayComponent) => renderDay({day, selectedDate, dayComponent})} />
                  </Col>
                </Row>
                {availableSlots?.length > 0 ? (
                  <>
                    <Row>
                      <Col>Select Slot</Col>
                    </Row>
                    <Row
                      style={{
                        rowGap: "0.5rem",
                        marginBottom: "1.5rem",
                        marginTop: "0.5rem",
                      }}
                    >
                      {availableSlots?.map((slot, index) => {
                        let time;
                        let localTime;
                        if (slot?.status === "busy-reserved") {
                          localTime = moment(slot?.start).format("HH:mm");
                        } else {
                          localTime = moment(slot?.start).format("HH:mm");
                        }

                        return (
                          <Col
                            style={{
                              background:
                                selectedSlot === slot?.start
                                  ? "#6c757d38"
                                  : "#ffff",
                              width: "14.666667%",
                            }}
                            sm={2}
                            className="slotStyle"
                            key={index}
                            onClick={() => {
                              formik?.setFieldValue("availableSlot", slot);
                              setSelectedSlot(slot?.start);
                            }}
                          >
                            {localTime}
                          </Col>
                        );
                      })}
                    </Row>
                  </>
                ) : (
                  <div
                    className="error-text"
                    style={{
                      marginBottom: "1.5rem",
                      display: slotUnavailable ? "block" : "none",
                    }}
                  >
                    No Available Slots
                  </div>
                )}

                {slotsLoading ? (
                  <>
                    <Row>
                      <Col>Select Slot</Col>
                    </Row>
                    <Skeleton height={50} />
                  </>
                ) : null}
                <Row>
                  <Col>
                    <Form.Check.Label
                      style={{ textTransform: "capitalize", fontSize: "14px" }}
                    >
                      {"preferred channel ?"}
                    </Form.Check.Label>{" "}
                    <span className="requiredField">&#42;</span>
                    <br />
                    {["phone", "video/chat"].map((val) => (
                      <Form.Check
                        style={{
                          textTransform: "capitalize",
                          fontSize: "14px",
                          marginRight: "65px",
                        }}
                        inline
                        checked={formik.values.preferredChannel === val}
                        type={"radio"}
                        label={val}
                        id={val}
                        name="preferred channel"
                        onChange={(e) =>
                          formik.setFieldValue("preferredChannel", e.target.id)
                        }
                      />
                    ))}
                    {formik?.touched["preferredChannel"] &&
                    formik?.errors["preferredChannel"] ? (
                      <div className="error-text">
                        {formik?.errors["preferredChannel"]}{" "}
                      </div>
                    ) : null}
                  </Col>
                  {type !== "patient" ? null : (
                    <>
                      <Col>
                        <Row>
                          <Col>
                            <TextInput
                              keyField={"returnTelephoneNumber"}
                              type="phone"
                              label={"Return Telephone Number"}
                              formik={formik}
                              disabled={false}
                              placeholder={"Return Telephone Number"}
                              required={true}
                            />
                          </Col>
                          <Col>
                            <TextInput
                              style={{ marginTop: "1.7rem", width: "5.0rem" }}
                              keyField={"returnTelephoneNumberExt"}
                              label={"Ext."}
                              formik={formik}
                              disabled={false}
                              placeholder={"Ext."}
                              required={false}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </>
                  )}
                </Row>

                <Row></Row>
                <Row></Row>
              </>
            )}
            <div className="btn-wrap">
              <Button
                onClick={() => {
                  onHide();
                }}
                variant="secondary"
                title="Cancel"
              >
                Cancel
              </Button>
              <Button type="submit" isLoading={btnLoading}>
                Create
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ScheduleAppointmentWR;
